// extracted by mini-css-extract-plugin
export var subtitle = "text-module--subtitle--1NKG0";
export var before_title = "text-module--before_title--3JppB";
export var highlight = "text-module--highlight--SuspX";
export var green_highlight = "text-module--green_highlight--1w8eh";